module.exports = __webpack_public_path__ + "img/check_agenda_2.625d6d48.svg";